interface RateLimitData {
  count: number;
  lastReset: number;
}

const checkAndResetData = (data: RateLimitData): RateLimitData => {
  const RESET_INTERVAL = 24 * 60 * 60 * 1000; // 24 hours in milliseconds
  const now = Date.now();
  
  if (now - data.lastReset >= RESET_INTERVAL) {
    return { count: 0, lastReset: now };
  }
  return data;
};

export const checkRateLimit = (userId: string): boolean => {
  const KEY = `ad-submission-${userId}`;
  const MAX_REQUESTS = 2;
  const now = Date.now();
  const stored = localStorage.getItem(KEY);
  let data: RateLimitData = stored ? JSON.parse(stored) : { count: 0, lastReset: now };

  data = checkAndResetData(data);

  if (data.count >= MAX_REQUESTS) {
    return false;
  }

  data.count++;
  localStorage.setItem(KEY, JSON.stringify(data));
  return true;
};

export const getRemainingSubmissions = (userId: string): number => {
  const KEY = `ad-submission-${userId}`;
  const MAX_REQUESTS = 2;
  const stored = localStorage.getItem(KEY);
  
  if (!stored) return MAX_REQUESTS;
  
  const data: RateLimitData = checkAndResetData(JSON.parse(stored));
  localStorage.setItem(KEY, JSON.stringify(data)); // Save the reset data if needed
  return Math.max(0, MAX_REQUESTS - data.count);
};
